<template>
  <v-row no-gutters>
    <v-col cols="7">
      {{ __(translationKey) }}<br>
      <b>#{{ invoice.number }}</b>
    </v-col>
    <v-col cols="5" class="text-right">
      <div
        v-for="payment in invoice.orderPayments"
        :key="payment.id"
      >
        <span
          v-if="PaymentMethod.isCash(payment.paymentMethod)"
          v-text="__('inCash')"
        />
        <span
          v-else
          v-text="paymentMethod(payment.paymentMethod)"
        />
        {{ payment.payAmount | currency }}
      </div>
      <b>{{ __('total') }} {{ invoice.total | currency }}</b>
    </v-col>
  </v-row>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'
  import PaymentMethod from '@/Models/Static/PaymentMethod'

  export default {
    mixins: [
      Currenciable,
      I18n,
    ],

    props: {
      invoice: {
        required: true,
        type: Object,
      },
      refund: {
        required: true,
        type: Boolean,
      },
    },

    data: () => ({
      PaymentMethod,
    }),

    computed: {
      translationKey () {
        if (this.refund) {
          return 'refund'
        }
        if (this.invoice.notAccountable) {
          return 'notAccountable'
        }
        if (!! this.invoice.customerJSON?.nif) {
          return 'invoice'
        }
        return 'simplifiedInvoice'
      },
    },

    methods: {
      paymentMethod (id) {
        return this.$store.getters['rummage/paymentMethod'](id)?.name
          ?? `${this.__('paymentMethod')} [${id}]`
      },
    },
  }
</script>
